import StandingsTable from '../components/standings/StandingsTable'

export default function StandingsPage() {
  return <StandingsTable />
}
